/* src/app/modules/display/components/menus/product-menu/building-blocks/menu-header/menu-header-calyx-trichomes/menu-header-calyx-trichomes.component.scss */
/*# sourceMappingURL=menu-header-calyx-trichomes.component.css.map */
